export const loyaltyTextColor = (txtColor) => {
  switch (txtColor) {
    case 'gold':
      return 'text-loyalty-gold';
    case 'black':
      return 'text-loyalty-black';
    case 'platinum':
      return 'text-loyalty-platinum';
    case 'blue':
    default:
      return 'text-loyalty-blue';
  }
}
